import SystemModule, { ModuleType } from './SystemModule';

export interface RawSystemModule {
	type: string;
}

export default function mapSystemModule(module: RawSystemModule): SystemModule {
	return new SystemModule(module.type as ModuleType);
}
